import { phoneNumber } from './mask';
import { PaymentMethods } from './enums';
import { list as unitsList } from '../components/ReactComponent/Measurement/Units/utils';

const formApiToData = (data) => {
  const {
    accessorials,
    accList,
    division,
    paymentType,
    serviceType,
    from,
    to,
    thirdParty,
    items,
    measurementType,
    totalCharges,
    charges,
    quoteNumber,
    expiryDate,
    createDate,
    totalAmount,
    accountNumber,
    billToAccountNumber,
    serviceLevelCode,
    serviceLevelDescription,
    isStraightTruck,
    status,
    quoteEmail,
    emailAddress,
    referenceNumber,
    poNumber,
    specialInstructions,
    sendEmailToConsignee,
    droppingFreightOff,
    hasRegularPickups,
    shipmentType,
    shipmentId,
    probillNumber,
    emergencyPhoneNumber,
    erapPhoneNumber,
    erapReferenceNumber,
    contactName,
    quoteType,
    brokerEmail,
    brokerName,
    brokerPhoneNumber,
  } = data;

  const buildAddress = (obj) => {
    const address1 = (obj.address1 && obj.address1 !== 'null') ? obj.address1 : '';
    const city = (obj.city && obj.city !== 'null') ? obj.city : '';
    const province = (obj.provinceCode && obj.provinceCode !== 'null') ? `, ${obj.provinceCode}` : '';
    const countryCode = (obj.countryCode && obj.countryCode !== 'null') ? `, ${obj.countryCode}` : '';

    return (`${address1}, ${city} ${province} ${obj.postalCode} ${countryCode}`);
  };

  const shipperAddress = buildAddress(from);
  const consigneeAddress = buildAddress(to);
  const billingAddress = paymentType === 'ThirdParty' && thirdParty ? buildAddress(thirdParty) : '';
  const measurementList = items.map((each) => {
    const commodityType = (each.commodityType) ? each.commodityType : null;

    return ({
      commodityType,
      itemWeight: each.weight,
      itemLength: each.length,
      itemWidth: each.width,
      itemHeight: each.height,
      SkidQty: each.pallets,
      PieceQty: each.pieces,
      itemDescription: each.description,
      description: each.description,
      itemWeightUnit: each.weightUnitType !== undefined ? each.weightUnitType : null,
      itemLengthUnitType: each.lengthUnitType !== undefined ? each.lengthUnitType : null,
      itemNMFC: each.nmfc,
      itemClass: each.freightClass,
      completed: true,
      itemDangerous: each.isDangerousGoods,
      unNumber: each.unNumber,
      dgPrimaryClass: each.primaryClass,
      dgSubsidiaryClass: each.subClass,
      dgPackagingGroup: each.packagingGroup || '',
      dgPackagingType: each.packagingType || '',
      toxic: each.isToxicByInhalation,
      totalQuantity: each.quantity,
      totalQuantityUnits: each.quantityType,
      shippingName: each.shippingName,
      numberPackRequireLabel: each.numOfPackagesRequiringLabels,
      neq: each.isNEQ,
      itemFreightClass: each.freightClass,
    });
  });

  const updatedAccList = { ...accList };
  Object.keys(accList).forEach((acc) => {
    const code = accList[acc].code.value;
    const filteredAcc = accessorials.filter((item) => (item.code === code));
    const isSelected = (filteredAcc.length > 0);

    if (isSelected) {
      updatedAccList[acc].selected = true;

      // Copy the value (Amount) from the API response if it exists
      if (filteredAcc[0].value) {
        updatedAccList[acc].value = filteredAcc[0].value;
      }
    }
  });

  const formatBillToNumber = (accountNumber, billToAccountNumber) => {
    if (billToAccountNumber) {
      return billToAccountNumber?.accountNumber || billToAccountNumber;
    }

    if (accountNumber) {
      return accountNumber;
    }

    if (!accountNumber && !billToAccountNumber) {
      return null;
    }

    return null;
  };

  const billTo = formatBillToNumber(accountNumber, billToAccountNumber);

  const broker = {
    name: brokerName || '',
    phoneNumber: brokerPhoneNumber || '',
    emailAddress: brokerEmail || '',
  };

  return {
    accessorials: updatedAccList,
    consigneeCompanyName: to.companyName,
    consigneeContactName: to.contactName,
    consigneeAddress: (to.address1 && to.address1 !== 'null') ? consigneeAddress : '',
    consigneeAddressLine1: (to.address1 && to.address1 !== 'null') ? to.address1 : null,
    consigneeAddressAdditional: to.address2,
    consigneeCity: (to.city && to.city !== 'null') ? to.city : null,
    consigneeProvinceState: (to.provinceCode && to.provinceCode !== 'null') ? to.provinceCode : null,
    consigneePostalZipCode: to.postalCode,
    consigneeCountry: (to.countryCode === 'CA') ? 'Canada' : 'USA',
    consigneeEmail: to.contactEmail,
    consigneePhoneNumber: to.contactPhoneNumber && phoneNumber(to.contactPhoneNumber),
    consigneePhoneNumberExt: to.contactPhoneNumberExt,
    consigneeResidentialAddress: to.isResidential,
    division,
    paymentMethod: paymentType === 'ThirdParty' ? PaymentMethods.ThirdParty : paymentType,
    serviceType,
    serviceLevelCode,
    serviceLevelDescription,
    isStraightTruck,
    shipperCompanyName: from.companyName,
    shipperContactName: from.contactName,
    shipperAddress: (from.address1 && from.address1 !== 'null') ? shipperAddress : '',
    shipperAddressLine1: (from.address1 && from.address1 !== 'null') ? from.address1 : null,
    shipperAddressAdditional: from.address2,
    shipperCity: (from.city && from.city !== 'null') ? from.city : null,
    shipperProvinceState: (from.provinceCode && from.provinceCode !== 'null') ? from.provinceCode : null,
    shipperPostalZipCode: from.postalCode,
    shipperCountry: (from.countryCode === 'CA') ? 'Canada' : 'USA',
    shipperEmail: from.contactEmail,
    shipperPhoneNumber: from.contactPhoneNumber && phoneNumber(from.contactPhoneNumber),
    shipperPhoneNumberExt: from.contactPhoneNumberExt,
    shipperResidentialAddress: from.isResidential,
    billingCompanyName: thirdParty && thirdParty.companyName,
    billingContactName: thirdParty && thirdParty.contactName,
    billingAddress,
    billingAddressAdditional: thirdParty && thirdParty.address2,
    billingEmail: thirdParty && thirdParty.contactEmail,
    billingPhoneNumber: thirdParty && thirdParty.contactPhoneNumber && phoneNumber(thirdParty.contactPhoneNumber),
    billingPhoneNumberExt: thirdParty && thirdParty.contactPhoneNumberExt,
    measurementList,
    measurementType: unitsList.find((mt) => mt.value === measurementType),
    totalCharges: totalCharges && totalCharges.value ? totalCharges.value : 0,
    charges,
    billTo,
    quoteNumber,
    expiryDate,
    status,
    created: createDate,
    quoteDest: quoteEmail || emailAddress,
    totalAmount: totalAmount && totalAmount.value ? totalAmount.value : 0,
    referenceNumber,
    poNumber,
    specialInstructions,
    shipmentType: (shipmentType) || 'Regular',
    shipmentId,
    probillNumber,
    emergencyPhone: emergencyPhoneNumber && phoneNumber(emergencyPhoneNumber),
    erapPhone: erapPhoneNumber && phoneNumber(erapPhoneNumber),
    erapReference: erapReferenceNumber,
    dgContactName: contactName || '',
    quoteType,
    sendConsigneeInfo: sendEmailToConsignee,
    hasDroppingFreightOff: droppingFreightOff,
    hasRegularPickups,
    broker,
  };
};

export default formApiToData;
